import Spinner from './Spinner';

const AppReadyLoading = (): JSX.Element => {
  return <Spinner active top={'50%'} />;
};

export default AppReadyLoading;
